// form contact

let formContactValidator = null;
let lang;

const formContactInitValidator = function() {
    if (formContactValidator == null) {
        if ($('#form-contact').length) {
            lang = 'EN';
        } else if ($('#form-contact-es').length) {
            lang = 'ES';
        }
        if ('EN' == lang) {
            formContactValidator = $('#form-contact').validate({
                rules: {
                    contact_name: {
                        required: true
                    },
                    contact_lastname: {
                        required: true
                    },
                    contact_email: {
                        required: true,
                        email: true
                    },
                    contact_phone: {
                        required: true
                    },
                    contact_comments: {
                        required: true
                    },
                    contact_accept: {
                        required: true
                    }
                },
                messages: {
                    contact_name: {
                        required: 'Write your name, please'
                    },
                    contact_lastname: {
                        required: 'Write your last name, please'
                    },
                    contact_email: {
                        required: 'Write your email, please',
                        email: 'The email is not correct'
                    },
                    contact_phone: {
                        required: 'Write your phone number, please'
                    },
                    contact_comments: {
                        required: 'Write your message, please'
                    },
                    contact_accept: {
                        required: 'It is necessary to read and accept the legal notice'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        } else if ('ES' == lang) {
            formContactValidator = $('#form-contact-es').validate({
                rules: {
                    contact_name: {
                        required: true
                    },
                    contact_lastname: {
                        required: true
                    },
                    contact_email: {
                        required: true,
                        email: true
                    },
                    contact_phone: {
                        required: true
                    },
                    contact_comments: {
                        required: true
                    },
                    contact_accept: {
                        required: true
                    }
                },
                messages: {
                    contact_name: {
                        required: 'Escriba su nombre, por favor'
                    },
                    contact_lastname: {
                        required: 'Escriba sus apellidos, por favor'
                    },
                    contact_email: {
                        required: 'Escriba su email, por favor',
                        email: 'El email no es correcto'
                    },
                    contact_phone: {
                        required: 'Escriba su teléfono, por favor'
                    },
                    contact_comments: {
                        required: 'Escriba sus comentarios, por favor'
                    },
                    contact_accept: {
                        required: 'Es necesario leer y aceptar el aviso legal'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        }
    }
};
const formContactSend = function() {
    $('#contact-success').addClass('d-none');
    $('#contact-error').addClass('d-none');
    formContactInitValidator();
    let url;
    if ('EN' == lang) {
        if (!$('#form-contact').valid()) {
            return false;
        }
        url = '/api/formulario/send2';
    } else if ('ES' == lang) {
        if (!$('#form-contact-es').valid()) {
            return false;
        }
        url = '/api/formulario/es/send2';
    }
    $('#btn-contact-send').addClass('d-none');
    $('#btn-contact-sending').removeClass('d-none');
    const payload = {
        name: $('#contact_name').val(),
        surname: $('#contact_lastname').val(),
        email: $('#contact_email').val(),
        phone: $('#contact_phone').val(),
        comments: $('#contact_comments').val(),
        subject: 'Helicópteros Sanitarios: formulario "contact form"'
    };
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'POST',
        url: url,
        data: JSON.stringify(payload),
        dataType: 'json',
        success: function (data, status, jqXHR) {
            $('#btn-contact-send').removeClass('d-none');
            $('#btn-contact-sending').addClass('d-none');
            if ('OK' == data.status) {
                $('#contactus_name,#contactus_lastname,#contactus_email,#contactus_phone,#contactus_comments').val('');
                //$('#contact-success').html(data.message).removeClass('d-none');
                if ('EN' == lang) {
                    document.location.href = './thanks.html';
                } else if ('ES' == lang) {
                    document.location.href = './gracias.html';
                }
            } else {
                $('#contact-error').html(data.message).removeClass('d-none');
            }
        },
        error: function (jqXHR, status) {
            $('#btn-contact-send').removeClass('d-none');
            $('#btn-contact-sending').addClass('d-none');
            if ('EN' == lang)
                $('#contact-error').html('Your message has not been delivered, please try again.<br />If the problem persists please contact us at: info@helicopterossanitarios.com<br />Sorry for the inconvenience.').removeClass('d-none');
            else if ('ES' == lang)
                $('#contact-error').html('Su mensaje no ha podido ser entregado, por favor inténtelo más tarde.<br />Si el problema persiste, póngase en contacto con nosotros en: info@helicopterossanitarios.com<br />Disculpe las molestias.').removeClass('d-none');
        }
    });
    return false;
};
  
window.formContactSend = formContactSend;

// form callback

let formCallbackValidator = null;

const formCallbackInitValidator = function() {
    if (formCallbackValidator == null) {
        if ($('#form-callback').length) {
            lang = 'EN';
        } else if ($('#form-callback-es').length) {
            lang = 'ES';
        }
        if ('EN' == lang) {
            formCallbackValidator = $('#form-callback').validate({
                rules: {
                    callback_name: {
                        required: true
                    },
                    callback_phone: {
                        required: true
                    },
                    callback_accept: {
                        required: true
                    }
                },
                messages: {
                    callback_name: {
                        required: 'Write your name, please'
                    },
                    callback_phone: {
                        required: 'Write your phone number, please'
                    },
                    callback_accept: {
                        required: 'It is necessary to read and accept the legal notice'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        } else if ('ES' == lang) {
            formCallbackValidator = $('#form-callback-es').validate({
                rules: {
                    callback_name: {
                        required: true
                    },
                    callback_phone: {
                        required: true
                    },
                    callback_accept: {
                        required: true
                    }
                },
                messages: {
                    callback_name: {
                        required: 'Escriba su nombre, por favor'
                    },
                    callback_phone: {
                        required: 'Escriba su teléfono, por favor'
                    },
                    callback_accept: {
                        required: 'Es necesario leer y aceptar el aviso legal'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        }
    }
};
const formCallbackSend = function() {
    $('#callback-success').addClass('d-none');
    $('#callback-error').addClass('d-none');
    formCallbackInitValidator();
    let url;
    if ('EN' == lang) {
        if (!$('#form-callback').valid()) {
            return false;
        }
        url = '/api/formulario/send3';
    } else if ('ES' == lang) {
        if (!$('#form-callback-es').valid()) {
            return false;
        }
        url = '/api/formulario/es/send3';
    }
    $('#btn-callback-send').addClass('d-none');
    $('#btn-callback-sending').removeClass('d-none');
    const payload = {
        name: $('#callback_name').val(),
        phone: $('#callback_phone').val(),
        subject: 'Helicópteros Sanitarios: formulario "request a callback"'
    };
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'POST',
        url: url,
        data: JSON.stringify(payload),
        dataType: 'json',
        success: function (data, status, jqXHR) {
            $('#btn-callback-send').removeClass('d-none');
            $('#btn-callback-sending').addClass('d-none');
            if ('OK' == data.status) {
                $('#contactus_name,#contactus_phone').val('');
                //$('#callback-success').html(data.message).removeClass('d-none');
                if ('EN' == lang) {
                    document.location.href = './thanks.html';
                } else if ('ES' == lang) {
                    document.location.href = './gracias.html';
                }
            } else {
                $('#callback-error').html(data.message).removeClass('d-none');
            }
        },
        error: function (jqXHR, status) {
            $('#btn-callback-send').removeClass('d-none');
            $('#btn-callback-sending').addClass('d-none');
            if ('EN' == lang)
                $('#callback-error').html('Your message has not been delivered, please try again.<br />If the problem persists please contact us at: info@helicopterossanitarios.com<br />Sorry for the inconvenience.').removeClass('d-none');
            else if ('ES' == lang)
                $('#callback-error').html('Su mensaje no ha podido ser entregado, por favor inténtelo más tarde.<br />Si el problema persiste, póngase en contacto con nosotros en: info@helicopterossanitarios.com<br />Disculpe las molestias.').removeClass('d-none');
        }
    });
    return false;
};
  
window.formCallbackSend = formCallbackSend;